const vic = {
  title: 'Victoria',
  links: [
    {
      anchorText: 'Ballarat',
      searchAreaId: '29514',
      path: 'ballarat-vic',
    },
    {
      anchorText: 'Bendigo',
      searchAreaId: '29516',
      path: 'bendigo-vic',
    },
    {
      anchorText: 'Wodonga',
      searchAreaId: '29423',
      path: 'wodonga-vic',
    },
    {
      anchorText: 'Bright',
      searchAreaId: '21611',
      path: 'bright-vic',
    },
    {
      anchorText: 'Wangaratta',
      searchAreaId: '29524',
      path: 'wangaratta-vic',
    },
    {
      anchorText: 'Maryborough',
      searchAreaId: '30207',
      path: 'maryborough-vic',
    },
    {
      anchorText: 'Beechworth',
      searchAreaId: '21620',
      path: 'beechworth-vic',
    },
    {
      anchorText: 'Yackandandah',
      searchAreaId: '21626',
      path: 'yackandandah-vic',
    },
    {
      anchorText: 'Beaufort',
      searchAreaId: '20293',
      path: 'beaufort-vic',
    },
    {
      anchorText: 'Castlemaine',
      searchAreaId: '30205',
      path: 'castlemaine-vic',
    },
    {
      anchorText: 'Myrtleford',
      searchAreaId: '21601',
      path: 'myrtleford-vic-3737',
    },
    {
      anchorText: 'Echuca',
      searchAreaId: '21026',
      path: 'echuca-vic',
    },
    {
      anchorText: 'Colac Colac',
      searchAreaId: '21481',
      path: 'colac-colac-vic',
    },
    {
      anchorText: 'Mansfield',
      searchAreaId: '21528',
      path: 'mansfield-vic-3722',
    },
    {
      anchorText: 'Daylesford',
      searchAreaId: '30206',
      path: 'daylesford-vic',
    },
    {
      anchorText: 'Mount Beauty',
      searchAreaId: '21461',
      path: 'mount-beauty-vic',
    },
    {
      anchorText: 'Strathfieldsaye',
      searchAreaId: '20978',
      path: 'strathfieldsaye-vic',
    },
    {
      anchorText: 'Benalla',
      searchAreaId: '21330',
      path: 'benalla-vic-3672',
    },
    {
      anchorText: 'Shepparton',
      searchAreaId: '29522',
      path: 'shepparton-vic',
    },
    {
      anchorText: 'Rochester',
      searchAreaId: '21021',
      path: 'rochester-vic',
    },
    {
      anchorText: 'Golden Square',
      searchAreaId: '30211',
      path: 'golden-square-vic',
    },
    {
      anchorText: 'Kyneton',
      searchAreaId: '30204',
      path: 'kyneton-vic',
    },
    {
      anchorText: 'Rutherglen',
      searchAreaId: '21411',
      path: 'rutherglen-vic',
    },
    {
      anchorText: 'Heathcote',
      searchAreaId: '20840',
      path: 'heathcote-vic',
    },
    {
      anchorText: 'Creswick',
      searchAreaId: '20250',
      path: 'creswick-vic',
    },
    {
      anchorText: 'Maiden Gully',
      searchAreaId: '20969',
      path: 'maiden-gully-vic',
    },
    {
      anchorText: 'Kangaroo Flat',
      searchAreaId: '30212',
      path: 'kangaroo-flat-vic',
    },
    {
      anchorText: 'Falls Creek',
      searchAreaId: '21460',
      path: 'falls-creek-vic',
    },
    {
      anchorText: 'Corryong',
      searchAreaId: '21482',
      path: 'corryong-vic',
    },
    {
      anchorText: 'Woodend',
      searchAreaId: '20513',
      path: 'woodend-vic',
    },
    {
      anchorText: 'Clunes',
      searchAreaId: '20279',
      path: 'clunes-vic',
    },
    {
      anchorText: 'Stanley',
      searchAreaId: '21622',
      path: 'stanley-vic',
    },
    {
      anchorText: 'Trentham',
      searchAreaId: '20572',
      path: 'trentham-vic',
    },
    {
      anchorText: 'East Bendigo',
      searchAreaId: '30210',
      path: 'east-bendigo-vic',
    },
    {
      anchorText: 'Brown Hill',
      searchAreaId: '20133',
      path: 'brown-hill-vic',
    },
    {
      anchorText: 'Maldon',
      searchAreaId: '20615',
      path: 'maldon-vic',
    },
    {
      anchorText: 'Barnawartha',
      searchAreaId: '21413',
      path: 'barnawartha-vic',
    },
    {
      anchorText: 'Alfredton',
      searchAreaId: '30199',
      path: 'alfredton-vic',
    },
    {
      anchorText: 'Chiltern',
      searchAreaId: '21400',
      path: 'chiltern-vic',
    },
    {
      anchorText: 'Rushworth',
      searchAreaId: '21165',
      path: 'rushworth-vic',
    },
    {
      anchorText: 'Baranduda',
      searchAreaId: '21421',
      path: 'baranduda-vic',
    },
    {
      anchorText: 'Wahgunyah',
      searchAreaId: '21412',
      path: 'wahgunyah-vic',
    },
    {
      anchorText: 'Porepunkah',
      searchAreaId: '21610',
      path: 'porepunkah-vic',
    },
    {
      anchorText: 'Wendouree',
      searchAreaId: '30200',
      path: 'wendouree-vic',
    },
    {
      anchorText: 'Macedon',
      searchAreaId: '30203',
      path: 'macedon-vic',
    },
    {
      anchorText: 'Epsom',
      searchAreaId: '20959',
      path: 'epsom-vic',
    },
    {
      anchorText: 'Wedderburn',
      searchAreaId: '20827',
      path: 'wedderburn-vic',
    },
    {
      anchorText: 'Boort',
      searchAreaId: '20895',
      path: 'boort-vic',
    },
    {
      anchorText: 'Inglewood',
      searchAreaId: '20808',
      path: 'inglewood-vic',
    },
    {
      anchorText: 'Stanhope',
      searchAreaId: '21195',
      path: 'stanhope-vic',
    },
    {
      anchorText: 'Strathdale',
      searchAreaId: '20945',
      path: 'strathdale-vic',
    },
    {
      anchorText: 'Gordon',
      searchAreaId: '20124',
      path: 'gordon-vic',
    },
    {
      anchorText: 'Euroa',
      searchAreaId: '21301',
      path: 'euroa-vic',
    },
    {
      anchorText: 'Long Gully',
      searchAreaId: '20940',
      path: 'long-gully-vic',
    },
    {
      anchorText: 'Greendale',
      searchAreaId: '20111',
      path: 'greendale-vic',
    },
    {
      anchorText: 'Eppalock',
      searchAreaId: '20958',
      path: 'eppalock-vic',
    },
    {
      anchorText: 'Tangambalanga',
      searchAreaId: '21449',
      path: 'tangambalanga-vic',
    },
    {
      anchorText: 'Newstead',
      searchAreaId: '20607',
      path: 'newstead-vic',
    },
    {
      anchorText: 'Eaglehawk',
      searchAreaId: '30213',
      path: 'eaglehawk-vic',
    },
    {
      anchorText: 'Delacombe',
      searchAreaId: '30201',
      path: 'delacombe-vic',
    },
    {
      anchorText: 'Canadian',
      searchAreaId: '20134',
      path: 'canadian-vic',
    },
    {
      anchorText: 'Kyabram',
      searchAreaId: '21182',
      path: 'kyabram-vic-3620',
    },
    {
      anchorText: 'Leneva',
      searchAreaId: '21442',
      path: 'leneva-vic',
    },
    {
      anchorText: 'Tawonga',
      searchAreaId: '21457',
      path: 'tawonga-vic',
    },
    {
      anchorText: 'Buninyong',
      searchAreaId: '20241',
      path: 'buninyong-vic',
    },
    {
      anchorText: 'Tallangatta',
      searchAreaId: '21466',
      path: 'tallangatta-vic',
    },
    {
      anchorText: 'Eskdale',
      searchAreaId: '21469',
      path: 'eskdale-vic',
    },
    {
      anchorText: 'Ascot',
      searchAreaId: '20258',
      path: 'ascot-vic-3364',
    },
    {
      anchorText: 'Ross Creek',
      searchAreaId: '20163',
      path: 'ross-creek-vic',
    },
    {
      anchorText: 'Bakery Hill',
      searchAreaId: '20126',
      path: 'bakery-hill-vic-3350',
    },
    {
      anchorText: 'Walwa',
      searchAreaId: '21493',
      path: 'walwa-vic',
    },
    {
      anchorText: 'Mount Helen',
      searchAreaId: '20140',
      path: 'mount-helen-vic',
    },
    {
      anchorText: 'Lake Eildon',
      searchAreaId: '21498',
      path: 'lake-eildon-vic',
    },
    {
      anchorText: 'Axedale',
      searchAreaId: '20952',
      path: 'axedale-vic',
    },
    {
      anchorText: 'Buckland',
      searchAreaId: '21608',
      path: 'buckland-vic',
    },
    {
      anchorText: 'Bonnie Doon',
      searchAreaId: '21526',
      path: 'bonnie-doon-vic',
    },
    {
      anchorText: 'Dean',
      searchAreaId: '20252',
      path: 'dean-vic',
    },
    {
      anchorText: 'Dederang',
      searchAreaId: '21430',
      path: 'dederang-vic',
    },
    {
      anchorText: 'Sedgwick',
      searchAreaId: '20977',
      path: 'sedgwick-vic',
    },
    {
      anchorText: 'Hepburn',
      searchAreaId: '20587',
      path: 'hepburn-vic-3461',
    },
    {
      anchorText: 'Ballan',
      searchAreaId: '20115',
      path: 'ballan-vic',
    },
    {
      anchorText: 'Pyramid Hill',
      searchAreaId: '21071',
      path: 'pyramid-hill-vic',
    },
    {
      anchorText: 'Whitfield',
      searchAreaId: '21586',
      path: 'whitfield-vic',
    },
    {
      anchorText: 'Wandiligong',
      searchAreaId: '21618',
      path: 'wandiligong-vic',
    },
    {
      anchorText: 'Taradale',
      searchAreaId: '20539',
      path: 'taradale-vic',
    },
    {
      anchorText: 'Charleroi',
      searchAreaId: '21454',
      path: 'charleroi-vic',
    },
    {
      anchorText: 'Osbornes Flat',
      searchAreaId: '21445',
      path: 'osbornes-flat-vic',
    },
    {
      anchorText: 'Sebastian',
      searchAreaId: '20998',
      path: 'sebastian-vic',
    },
    {
      anchorText: 'Arnold',
      searchAreaId: '20948',
      path: 'arnold-vic',
    },
    {
      anchorText: 'Lal Lal',
      searchAreaId: '20202',
      path: 'lal-lal-vic',
    },
    {
      anchorText: 'Adelaide Lead',
      searchAreaId: '20622',
      path: 'adelaide-lead-vic',
    },
    {
      anchorText: 'Glenpatrick',
      searchAreaId: '20650',
      path: 'glenpatrick-vic',
    },
    {
      anchorText: 'Amphitheatre',
      searchAreaId: '20645',
      path: 'amphitheatre-vic',
    },
    {
      anchorText: 'Jarvis Creek',
      searchAreaId: '21465',
      path: 'jarvis-creek-vic',
    },
    {
      anchorText: 'Smythesdale',
      searchAreaId: '20166',
      path: 'smythesdale-vic',
    },
    {
      anchorText: 'Pine Mountain',
      searchAreaId: '21492',
      path: 'pine-mountain-vic',
    },
    {
      anchorText: 'Gapsted',
      searchAreaId: '21596',
      path: 'gapsted-vic',
    },
    {
      anchorText: 'Talgarno',
      searchAreaId: '21448',
      path: 'talgarno-vic',
    },
    {
      anchorText: 'Harcourt',
      searchAreaId: '20561',
      path: 'harcourt-vic',
    },
    {
      anchorText: 'Koetong',
      searchAreaId: '21477',
      path: 'koetong-vic',
    },
  ],
};

export { vic };
